import { type AnalyticsPlacementTypes, sendEvent } from '@core/analytics'
import { setPlaybackContext } from './playbackAnalyticsContext'
import { playerPlacementPayload } from './playerEvents'

export const sendPlayPauseClick = (
    audioId: string,
    placement: AnalyticsPlacementTypes,
    willPlay: boolean,
) => {
    const payload = playerPlacementPayload(audioId, placement)

    if (willPlay) {
        sendEvent({ name: 'play_button_click', payload })
        setPlaybackContext('play', placement)

        return
    }

    sendEvent({ name: 'pause_button_click', payload })
    setPlaybackContext('pause', placement)
}
